import { openDialog } from "vue3-promise-dialog"
import ThinkingPictogram from "@/assets/pngs/Thinking.png"
import DeleteDialog from "@/components/Dialog/DeleteDialog.vue"
import KPromiseDialog from "@/components/Dialog/KPromiseDialog.vue"
import PictogramDialog from "@/components/Dialog/PictogramDialog.vue"

// If the error needs to show a dialog to the user show it and return true.
// In future this should use a unique error code in the UI/engine API.
export async function error_requires_message(error: any): Promise<boolean> {
  if (error.message.startsWith("category can not be unset")) {
    await openDialog<any>(KPromiseDialog, {
      title: "Remove failed",
      body: "It looks like the data you are trying to remove is in use. You will need to remove any values using this combination of items before trying to remove this item.",
      hideCancelButton: true,
    })
    return true
  }

  return false
}

export function multiple_file_warning(): Promise<boolean> {
  return openDialog<any>(PictogramDialog, {
    open: true,
    title: "Multiple files upload is not supported",
    imagePath: ThinkingPictogram,
    okButton: "Continue",
    confirmDialog: false,
    body: [
      "We <strong>don’t support multiple files at once</strong> (not yet).",
      "If you upload more files simultaneously, we’ll process only one, picking the name that comes first in alphabetical order.",
    ],
  })
}

export function delete_entity_message(entityName: string, hasIntegration: boolean) {
  let title = `Delete “${entityName}” and associated values`
  let body = ["Deleting this item will also delete any associated cell values."]
  let okButton = "Confirm and lose data"
  if (hasIntegration) {
    title = `Delete “${entityName}” and remove integration`
    body = [
      "<strong>Delete values and remove this integration?</strong>",
      "This will delete associated cell values and integration settings.",
    ]
    okButton = "Confirm and remove"
  }
  return openDialog<any>(DeleteDialog, {
    title,
    body,
    okButton,
    open: true,
    confirmDialog: true,
    holdToConfirm: true
  })
}

export function reset_model_warning(title: string): Promise<boolean> {
  return openDialog<any>(PictogramDialog, {
    open: true,
    title,
    imagePath: ThinkingPictogram,
    okButton: "Reset",
    confirmDialog: true,
    body: [
      "This action will reset your model and permanently overwrite your current data.",
    ],
  })
}
